import { BookingType } from '../enums/booking-type.enum';
import { BookingDate } from './booking-date.model';
import { Therapy } from './therapy.model';

export class Booking {
  public description: string;
  public email: string;
  public firstName: string;
  public isCompleted: boolean;
  public lastName: string;
  public phoneNumber: string;
  public practitionerId: string;
  public preferredContact: string;
  public referredBy: string;
  public requestedDates: BookingDate[];
  public services: Therapy[];
  public type: BookingType;

  public createdAt: number;
  public updatedAt: number;
  public id: string;

  constructor(description: string, email: string, firstName: string, isCompleted: boolean, lastName: string, phoneNumber: string,
              practitionerId: string, preferredContact: string, referredBy: string, requestedDates: BookingDate[],
              services: Therapy[], type: BookingType, createdAt: number, updatedAt: number, id?: string) {
    this.description = description;
    this.email = email;
    this.firstName = firstName;
    this.isCompleted = isCompleted;
    this.lastName = lastName;
    this.phoneNumber = phoneNumber;
    this.practitionerId = practitionerId;
    this.preferredContact = preferredContact;
    this.referredBy = referredBy;
    this.requestedDates = requestedDates;
    this.services = services;
    this.type = type;
    this.createdAt = createdAt;
    this.updatedAt = updatedAt;
    this.id = id;
  }

  public mapToFirestore(): any {
    return {
      description: this.description,
      email: this.email,
      firstName: this.firstName,
      isCompleted: this.isCompleted,
      lastName: this.lastName,
      phoneNumber: this.phoneNumber,
      practitionerId: this.practitionerId,
      preferredContact: this.preferredContact,
      referredBy: this.referredBy,
      requestedDates: BookingDate.mapArrayToFirestore(this.requestedDates),
      services: Therapy.mapArrayToFirestore(this.services),
      type: this.type,
      createdAt: this.createdAt,
      updatedAt: this.updatedAt
    };
  }

  static mapFromFirestore(booking: any, id: string) {
    return new Booking(
      booking.description,
      booking.email,
      booking.firstName,
      booking.isCompleted,
      booking.lastName,
      booking.phoneNumber,
      booking.practitionerId,
      booking.preferredContact,
      booking.referredBy,
      BookingDate.mapArrayFromFirestore(booking.requestedDates),
      Therapy.mapArrayFromFirestore(booking.services),
      booking.type,
      booking.createdAt,
      booking.updatedAt,
      id
    );
  }

  public static mapArrayFromFirestore(bookings: any[]): Booking[] {
    var bookingsArray: Booking[] = [];
    bookings.forEach((booking: any) => {
      bookingsArray.push(Booking.mapFromFirestore(booking, null));
    });
    return bookingsArray;
  }

  public static mapArrayToFirestore(bookings: Booking[]): any[] {
    var bookingsArray = [];
    bookings.forEach((booking: Booking) => {
      bookingsArray.push(booking.mapToFirestore());
    });
    return bookingsArray;
  }
}
